import { render } from "./ZoomOutSvg.vue?vue&type=template&id=a5833df2"
import script from "./ZoomOutSvg.vue?vue&type=script&lang=js"
export * from "./ZoomOutSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__